module.exports = __webpack_public_path__ + "static/img/logoWhite.fb15732.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoWhite.png
// module id = OY21
// module chunks = 3